// local
import {
  PRESIDENT,
  STATE_URL,
  TRENDS,
  USHOUSE_URL,
  LA_COUNTY_URL,
} from './constants.js';
import {
  renderSvelteComponent,
  findSvelteComponentContainer,
  findSvelteComponentContainers,
} from './utils/render.js';
import { createFeed, createRaceFeed } from './stores.js';
import HpEmbed from './components/HpEmbed.svelte';
import { get } from 'svelte/store';
import HpEmbedEevp from './components/HpEmbedEevp.svelte';
import BalanceOfPower from './components/BalanceOfPower.svelte';
import { SvelteComponent } from 'svelte';

const FEED_DICT = {
  'hp-president': {
    feed: PRESIDENT,
    svelteComponent: HpEmbed,
  },
  'hp-us-house': {
    feed: USHOUSE_URL,
    svelteComponent: BalanceOfPower,
  },
  'hp-state': {
    feed: STATE_URL,
    svelteComponent: HpEmbed,
  },
  'hp-trends': {
    feed: TRENDS,
    svelteComponent: HpEmbed,
  },
  'hp-los-angeles': {
    feed: LA_COUNTY_URL,
    svelteComponent: HpEmbed,
  },
};

// components

const crosswalk = window.CROSSWALK.assets.img;
async function main() {
  Object.keys(FEED_DICT).forEach((key) => {
    // Find them all and render them
    const elements = findSvelteComponentContainers(
      `[data-component-feed="${key}"]`
    );
    if (elements.length) {
      // create the correct feed
      (async (elements) => {
        let getFeed = FEED_DICT[key].feed;
        let svelteScript = FEED_DICT[key].svelteComponent;
        const feed = await createFeed(getFeed);
        elements.forEach((element) => {
          const contestEl = element.querySelector('.contest');
          const raceId = element.id;
          let race = /**  @type {import('./types.js').RaceFeed}  */ (
            createRaceFeed(feed, raceId)
          );
          renderSvelteComponent(
            svelteScript,
            /** @type {HTMLElement} */ contestEl,
            {
              race,
              crosswalk,
              name: raceId == '80-la' ? 'measure' : '',
            }
          );
        });
      })(elements);
    }
  });
}

main().catch(console.error);
